/**
 * 消費税率のマッピング定義
 * Excise rate mapping definitions
 */

/**
 * 消費税率から識別キーへのマッピング
 * Maps excise tax rates to identification keys
 * @example EXCISE_RATE_MAPPING[0.1] // "10percent"
 */
export const EXCISE_RATE_MAPPING: Record<number, string> = {
  0: '0percent',
  0.1: '10percent',
  0.08: '8percent',
  0.05: '5percent',
} as const;

/**
 * 識別キーから表示ラベルへのマッピング
 * Mapping from identification key to display label
 * @example EXCISE_LABELS['10percent'] // "10%対象"
 */
// TODO: use this for packages/apps/src/features/InvoiceReport/Edit/components/hooks/useCalcSummary.ts as well.
export const EXCISE_LABELS = {
  '0percent': '対象外',
  '5percent': '5%対象',
  '8percent': '8%対象',
  '10percent': '10%対象',
} as const;

/**
 * 表示順序
 * Display order
 */
export const EXCISE_DISPLAY_ORDER = [
  '10percent',
  '8percent',
  '5percent',
  '0percent',
];
